import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { getInteractor } from "services/local.service";
import { StorageUtil, toCamel } from "utils";
import { convertMillisecondsToDate } from "utils/date.utils";
import ChatTypography from "../../MessengerChat/ChatItem/ChatTypography";
import { KeyConstant, LangConstant, SystemConstant } from "const";
import { AppAvatar } from "components";
import { useCleanUpEffect } from "hooks";
import { getCommonLang, getNSLang } from "utils/lang.utils";
import { getLatestMessage } from "utils/view.utils";

const MessageThreadItem = ({ message, groupMembers }) => {
  const classes = useStyles();
  const prefixKey = StorageUtil.getCurrentPrefixKey();
  const branchId = StorageUtil.getItem(KeyConstant.KEY_BRANCH_ID, prefixKey);
  const { isMounted } = useCleanUpEffect();
  const [lastMessage, setLastMessage] = useState(message);
  const [accountDetail, setAccountDetail] = useState("");

  useEffect(() => {
    if (message) {
      getLatestMessage(prefixKey, toCamel(message)).then(lMessage=>{
        setLastMessage(lMessage)
      });
      getInteractor(prefixKey)
        .LocalAccountService.get(message.senderId, branchId)
        .then(account => {
          if (isMounted())
            setAccountDetail(toCamel({ ...account, name: account?.name || getCommonLang("TXT_USER_TRIOS") }));
        });
    }
  }, [message]);

  function getMessageContent(message) {
    if (message.sendType === SystemConstant.SEND_TYPE.notFound) {
      return getCommonLang("TXT_NOT_FOUND_MESSAGE");
    }
    if (message.messageEncryptStatus === SystemConstant.MESSAGE_ENCRYPT_STATUS.decryptRecover) {
      return getNSLang(LangConstant.NS_HOME_CONVERSATION, "TXT_DECRYPTING");
    }
    if (message?.messageEncryptStatus === SystemConstant.MESSAGE_ENCRYPT_STATUS.decryptFailed) {
      return getNSLang(LangConstant.NS_HOME_CONVERSATION, "TXT_DECRYPTING_FAIL");
    }
    if (message.isDeleteAll) {
      return getNSLang(LangConstant.NS_HOME_CONVERSATION, "TXT_DELETE_MSG_ALL");
    }
    if (message.isDeleteOnlyMe) {
      return getNSLang(LangConstant.NS_HOME_CONVERSATION, "TXT_DELETE_ONLY_ME");
    }

    return message.content;
  }

  const messageContent = getMessageContent(lastMessage);

  return (
    <Box className={classes.component}>
      <AppAvatar avatarId={accountDetail.avatarId} className={classes.accountAvatar} />
      <Box className={classes.content}>
        <Box className={classes.contentTitle}>
          <Typography>{accountDetail.name}</Typography>
          <Typography className={classes.textColor}>
            {convertMillisecondsToDate(message.created, "HH:mm - dd/MM/yyyy")}
          </Typography>
        </Box>
        <ChatTypography
          className={clsx(classes.textColor, "ellipsis")}
          mentionList={groupMembers}
          messageContent={messageContent}
          messageId={message.id}
          messageSourceId={message.sourceId}
        />
      </Box>
    </Box>
  );
};

export default MessageThreadItem;

const useStyles = makeStyles(theme => ({
  component: {
    display: "flex",
    alignItems: "center",
    padding: 10,
  },

  accountAvatar: {
    marginRight: 10,
  },

  content: {
    width: "100%",
  },

  contentTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  textColor: {
    color: theme.palette.grey[500],
    fontSize: "0.875rem",
  },
}));
